import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { UtilService, VariablesService } from '../../../shared/services';

@Component({
  selector: 'app-category-filters',
  templateUrl: './category-filters.component.html',
  styleUrls: ['./category-filters.component.scss']
})
export class CategoryFiltersComponent implements OnInit {

  appliedFilters;
  isUserLoggedIn = false;
  @Output() askLogin = new EventEmitter();
  @Input() filterData;
  @Input() attribute;

  constructor(
    private vars: VariablesService
  ) { }

  ngOnInit() {
    this.vars.appliedFilters.subscribe((res: any) => {
      this.appliedFilters = res;
    });
  }

  /**Emit the selected sidemenu cause value for updating results and other filters */
  applyCategory(category) {
    this.appliedFilters.category = category;
    this.vars.appliedFilters.next(this.appliedFilters);
  }

}
